import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MessageService } from '@services';
import { getErrorMessage } from '@utils';
import { firstValueFrom } from 'rxjs';
import { IntegracaoPagamentoService } from '../../../services/integracao-pagamento.service';
import { fadeInOutTranslate } from '../../../shared/elements/animation';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';

@Component({
  selector: 'app-modal-integracao-pagamento',
  templateUrl: './modal-integracao-pagamento.component.html',
  styleUrls: ['./modal-integracao-pagamento.component.css'],
  animations: [fadeInOutTranslate]
})
export class ModalIntegracaoPagamentoComponent extends ModalCadastroComponent implements OnInit, OnDestroy {
  @ViewChild('modal', { static: true }) modalPagamento;
  loadingStone: 'ENVIANDO_PEDIDO' | 'AGUARDANDO_PAGAMENTO' | 'PAGAMENTO_CONFIRMADO'
    | 'FALHA' | 'CANCELANDO_PEDIDO' | null = null;
  orderId = null;
  interromperConsulta = false;
  mensagemErro = null;
  pedidoFechado = false;

  constructor(
    private messageService: MessageService,
    private integracaoPagamentoService: IntegracaoPagamentoService,
  ) {
    super();
  }

  ngOnInit() {
    (document.activeElement as HTMLElement)?.blur(); // Remove o foco da tela anterior, para evitar que o Enter chame a modal novamente.
    this.orderId = null;
  }

  ngOnDestroy() {
    this.interromperConsulta = true;
  }

  show() {
    if (this.prop?.valor) {
      this.modalPagamento.show();
      this.criarPedidoCobranca(this.prop.valor, this.prop.formaPagamento, this.prop.parcelas,
        this.prop.nomeCliente, this.prop.nomeCobranca);
    } else {
      this.messageService.error('Integração pagamento: Valor inválido', 5000);
      this.fechar(false);
    }
  }

  async cancelarPagamento() {
    try {
      this.interromperConsulta = true;
      this.loadingStone = 'CANCELANDO_PEDIDO';

      await firstValueFrom(this.integracaoPagamentoService.cancelarPedido(this.orderId));
      
      this.fechar(false);
    } catch (err) {
      this.messageService.error(getErrorMessage(err), 8000);
      this.fechar(false);
    }
  }

  async criarPedidoCobranca(valor, formaPagamento, parcelas, nomeCliente, nomeCobranca) {
    try {
      this.interromperConsulta = false;
      this.loadingStone = 'ENVIANDO_PEDIDO';

      const res = await firstValueFrom(this.integracaoPagamentoService.criarPedido(valor, formaPagamento, parcelas, nomeCliente, nomeCobranca));
      this.orderId = res.orderId;

      this.loadingStone = 'AGUARDANDO_PAGAMENTO';
      for (let i = 0; i < 300; i++) { // 15 min
        try {
          await this.sleep(3000);
          
          if (this.interromperConsulta) {
            return; // Pedido foi cancelado, continuaram sem confirmar pagamento ou a modal fechou.
          }
          
          const resConsulta = await firstValueFrom(this.integracaoPagamentoService.consultarPedido(this.orderId));
          if (resConsulta === 'P') {
            await firstValueFrom(this.integracaoPagamentoService.fecharPedido(this.orderId));

            this.loadingStone = 'PAGAMENTO_CONFIRMADO';
            await this.sleep(5000);

            this.fechar(true);
            return;
          } else if (resConsulta === 'C') {
            this.messageService.error('Cobrança cancelada.', 5000);
            this.fechar(false);
            return;
          } else if (resConsulta === 'F') {
            this.messageService.success('Cobrança fechada.', 5000);
            this.fechar(true);
            return;
          }
        } catch (err) {
          this.messageService.error('Falha ao consultar cobrança: ' + getErrorMessage(err), 7000); // Tempo deve ser menor que os 2 outros waits juntos para não acumular
          await this.sleep(5000);
        }
      }

      await firstValueFrom(this.integracaoPagamentoService.cancelarPedido(this.orderId));

      this.loadingStone = 'FALHA';
      this.mensagemErro = 'Tempo máximo excedido.';
      this.pedidoFechado = true;
    } catch (err) {
      this.loadingStone = 'FALHA';
      this.mensagemErro = getErrorMessage(err);
    }
  }

  sleep(ms) {
    return new Promise((res, _) => { setTimeout(res, ms); });
  }

  fechar(adicionarPagamento: boolean) {
    this.closed.emit(adicionarPagamento);
  }

  async continuarSemPagamento() {
    try {
      this.interromperConsulta = true;
      this.loading['continuarSemPagamento'] = true;

      if (this.orderId && !this.pedidoFechado) {
        await firstValueFrom(this.integracaoPagamentoService.fecharPedido(this.orderId));
      }
      
      this.fechar(true);
    } catch (err) {
      this.messageService.error(getErrorMessage(err), 8000);
      this.fechar(true);
    }
  }
}
